import { __ } from '@wordpress/i18n';

const AddControl = ({ onClick, label = __('Add', 'faqmate-blocks') }) => {
    return (
        <button onClick={onClick} className="faqmate-add-btn">
            {/* <span className="dashicons dashicons-insert"></span> */}
            {label}
        </button>
    );
};

export default AddControl;
